// extracted by mini-css-extract-plugin
export default {"chat-kb-search":"chat-kb-search__zSUeRVnu8eil"};